var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M523 684L523 712",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 523.5,
    cy: 679.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M518.987 679.19C518.987 675.283 522.288 672.117 526.358 672.117C526.943 672.117 527.511 672.184 528.056 672.308C526.742 671.48 525.187 671 523.519 671C518.814 671 515 674.806 515 679.5C515 684.194 518.814 688 523.519 688C525.814 688 527.895 687.093 529.427 685.62C528.492 686.032 527.454 686.263 526.358 686.263C522.288 686.263 518.987 683.096 518.987 679.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M532.402 678.6L532.37 676.146L530.535 677.719L528.304 677.056L529.112 679.337L527.765 681.381L530.1 681.218L531.499 683.144L532.133 680.763L534.345 679.909L532.402 678.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.d4e1fcaacc452300eb1335a0d7b50830.svg";
export { ForwardRef as ReactComponent };